<template>
  <v-menu
    v-model="menu"
    class="date-picker"
    :close-on-content-click="false"
    :disabled="disabled"
    transition="scale-transition"
    offset-y
    :nudge-right="40"
    min-width="290px"
  >
    <template v-slot:activator="{ on }">
      <v-text-field
        v-model="formattedDate"
        v-validate="validator"
        outlined
        class="input input-data-nascimento"
        :solo="solo"
        :error-messages="errorMessages"
        data-vv-validate-on="change|input"
        :name="name"
        :disabled="disabled"
        :hide-details="hideDetails"
        :label="label"
        readonly
        :prepend-inner-icon="iconName"
        v-on="on"
      />
    </template>
    <v-date-picker ref="picker" v-model="computedDate" :type="type" locale="pt-BR" :max="max" :min="min" @input="input" />
  </v-menu>
</template>

<script>
import _ from 'lodash'

export default {
  inject: ['$validator'],
  props: {
    label: String,
    value: String,
    singleLine: Boolean,
    max: {
      type: String,
      default: () => new Date().toISOString().substr(0, 10)
    },
    min: String,
    icon: Boolean,
    outline: Boolean,
    hideDetails: Boolean,
    solo: Boolean,
    disabled: Boolean,
    errorMessages: [Array, String],
    type: String,
    validator: Object,
    name: String
  },
  data: () => ({
    menu: false
  }),
  computed: {
    computedDate: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      }
    },
    formattedDate() {
      return this.formatDate(this.value)
    },
    iconName() {
      if (this.icon) return 'event'
      return ''
    }
  },
  watch: {
    menu(val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'))
    }
  },
  methods: {
    formatDate(date) {
      if (!date) return null
      if (this.type === 'month') {
        return _.capitalize(this.$moment(date, 'YYYY-MM').format('MMMM [de] YYYY'))
      }
      return this.$moment(date, 'YYYY-MM-DD').format('DD/MM/YYYY')
    },
    input(value) {
      this.$emit('input', value)
      this.menu = false
    }
  }
}
</script>
<style lang="scss">
.date-picker {
  .v-text-field__details {
    margin: 0 !important;
  }
}
</style>
